import { render, staticRenderFns } from "./newHostingDetailsUpdate.vue?vue&type=template&id=d6a196f4&scoped=true"
import script from "./newHostingDetailsUpdate.vue?vue&type=script&lang=js"
export * from "./newHostingDetailsUpdate.vue?vue&type=script&lang=js"
import style0 from "./newHostingDetailsUpdate.vue?vue&type=style&index=0&id=d6a196f4&prod&lang=css"
import style1 from "./newHostingDetailsUpdate.vue?vue&type=style&index=1&id=d6a196f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6a196f4",
  null
  
)

export default component.exports